import { FadeIn } from "@/components/FadeIn";

const STEPS = [
  {
    number: "01",
    title: "Assess",
    body: (
      <>
        A free conversation about your land, water, and goals to understand whether pond
        <br className="hidden lg:block" /> aquaculture is a good fit for your property.
      </>
    ),
  },
  {
    number: "02",
    title: "Learn",
    body: (
      <>
        Pond ecology, water chemistry, hardy species, and Alberta's regulations to build
        <br className="hidden lg:block" /> a strong foundation for managing your pond.
      </>
    ),
  },
  {
    number: "03",
    title: "Plan",
    body: (
      <>
        A realistic plan shaped to your property: siting, stocking, compliance, budget,
        <br className="hidden lg:block" /> and timeline.
      </>
    ),
  },
  {
    number: "04",
    title: "Steward",
    body: (
      <>
        Seasonal training and ongoing consulting to read your water, prevent winterkill,
        <br className="hidden lg:block" /> and adapt year after year.
      </>
    ),
  },
];

export const LearningPath = () => {
  return (
    <section id="learning-path" data-testid="learning-path-section" className="bg-background">
      {/* Narrow chapter intro */}
      <div className="mx-auto w-full max-w-[880px] px-5 sm:px-8 pt-[25px] lg:pt-[60px] pb-2">
        <FadeIn>
          <h2 className="font-serif-heading font-medium text-4xl sm:text-5xl lg:text-[clamp(2.25rem,2.9vw+0.5rem,3.4rem)] leading-[1.05] tracking-[-0.015em] text-foreground lg:text-center">
            For thoughtful stewards
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-foreground/65 lg:whitespace-nowrap lg:text-center">
            There is a right order to this work — four steps taken deliberately.
          </p>
        </FadeIn>
      </div>

      {/* The four movements */}
      <div className="mx-auto w-full max-w-[1010px] px-5 sm:px-8 pt-[35px] sm:pt-14 pb-[50px] lg:pb-10">
        {STEPS.map((step, i) => (
          <FadeIn key={step.number} delay={i * 0.06}>
            <div
              data-testid={`learning-path-step-${i + 1}`}
              tabIndex={0}
              className="path-row hairline grid grid-cols-12 gap-x-4 gap-y-3 items-center py-6 sm:py-9 px-2 sm:px-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              <div className="col-span-2 sm:col-span-2 lg:col-span-2">
                <span className="font-serif-heading font-light text-[2.25rem] sm:text-[3rem] lg:text-[3.5rem] leading-[0.9] text-[color:var(--apn-sage)] select-none">
                  {step.number}
                </span>
              </div>
              <div className="col-span-10 sm:col-span-3 lg:col-span-2">
                <h3 className="font-serif-heading text-2xl sm:text-[1.7rem] lg:text-3xl font-medium text-foreground">
                  {step.title}
                </h3>
              </div>
              <div className="col-span-12 sm:col-span-7 lg:col-span-8">
                <p className="text-sm sm:text-base leading-[1.7] text-foreground/70 max-w-[64ch] lg:max-w-none">
                  {step.body}
                </p>
              </div>
            </div>
          </FadeIn>
        ))}
        <div className="hairline" />

        <FadeIn delay={0.1}>
          <p className="mt-7 font-mono-meta text-[10px] text-foreground/45">
            The first step is free. →{" "}
            <button
              data-testid="learning-path-cta-link"
              onClick={() => {
                const el = document.querySelector("#book");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className="nav-underline normal-case tracking-normal font-sans text-xs font-medium text-[color:var(--apn-forest)]"
            >
              Book your consultation.
            </button>
          </p>
        </FadeIn>
      </div>
    </section>
  );
};
